import { Component, Input, OnDestroy, OnInit } from '@angular/core';
import { FormControl } from '@angular/forms';
import { ReplaySubject, Subject, takeUntil } from 'rxjs';

@Component({
  selector: 'fca-filter-search',
  templateUrl: './filter-search.component.html',
  styleUrl: './filter-search.component.scss',
})
export class FilterSearchComponent implements OnInit, OnDestroy {
  @Input() label!: string;
  @Input() control!: FormControl;

  _data: { id: string | number; value: string }[] | null = null;
  @Input() set data(value: { id: string | number; value: string }[] | null) {
    this._data = value;
    if (!this.data?.some((entry) => entry.id === this.control.value)) {
      this.control.reset(null);
    }
    this.filteredData.next(value?.slice() ?? []);
  }
  get data(): { id: string | number; value: string }[] | null {
    return this._data;
  }

  filteredCtrl = new FormControl<string>('');
  filteredData = new ReplaySubject<{ id: string | number; value: string }[]>(1);

  protected _onDestroy = new Subject<void>();

  ngOnInit(): void {
    this.filteredCtrl.valueChanges
      .pipe(takeUntil(this._onDestroy))
      .subscribe((value) => {
        this.filterData(value);
      });
  }

  ngOnDestroy() {
    this._onDestroy.next();
    this._onDestroy.complete();
  }

  filterData(value: string | null): void {
    if (!value) {
      this.filteredData.next(this.data?.slice() ?? []);
      return;
    }

    const loweredCaseValue = value.toLowerCase();

    this.filteredData.next(
      this.data?.filter((entry) =>
        entry.value.toLowerCase().includes(loweredCaseValue)
      ) ?? []
    );
  }

  clear() {
    this.control.reset(null);
  }
}
